import React from 'react';
import Chip from '@material-ui/core/Chip';
import { makeStyles } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import PropTypes from 'prop-types';
import AvatarReco from './AvatarReco';
import RtlWrapper from '../../helpers/RtlWrapper';

const useStyles = makeStyles(() => ({
  root: {
    maxWidth: '100px',
    backgroundColor: '#A0F4FF',
    marginInlineEnd: 8,
    color: '#000000',
    textOverflow: 'ellipsis',
    '&:focus': {
      backgroundColor: '#A0F4FF'
    }
  }
}));
const RoundedChip = (props) => {
  const classes = useStyles();
  return (
    <RtlWrapper>
      <Chip
        className={classes.root}
        deleteIcon={<ClearIcon />}
        label={props.name}
        onDelete={props.onDelete}
        avatar={
          props.avatar ? <AvatarReco size={3} avatar={props.avatar} /> : null
        }
        size="small"
      />
    </RtlWrapper>
  );
};

RoundedChip.propTypes = {
  name: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
  avatar: PropTypes.string
};

export default RoundedChip;
